"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _session = require("./session");
var _appconfig = require("./appconfig");
var _menu = require("./menu");
var _notifications = require("./notifications");
var _toasts = require("./toasts");
var _snacks = require("./snacks");
var _ua = require("./ua");
var _default = config => (0, _redux.combineReducers)({
  session: _session.session,
  appconfig: (0, _appconfig.appconfig)(config),
  menu: _menu.menu,
  notifications: _notifications.notifications,
  toasts: _toasts.toasts,
  snacks: _snacks.snacks,
  ua: _ua.ua
});
exports.default = _default;